export default "__VITE_ASSET__DDDhHB_R__"